import * as TYPES from '../types';

export const addTrainingCategoryAction = (payload) => {
    return {
        type: TYPES.ADD_TRAINING_CATEGORY,
        payload: payload
    };
};

export const getAllTrainingCategoryAction = () => {
    return {
        type: TYPES.GET_ALL_TRAINING_CATEGORY,
    };
};

export const getAllTrainingCategorySuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_TRAINING_CATEGORY_SUCCESS,
        payload: payload
    };
};

export const deleteTrainingCategoryAction = (payload) => {
    return {
        type: TYPES.DELETE_TRAINING_CATEGORY,
        payload: payload
    };
};


export const addTrainingAction = (payload) => {
    return {
        type: TYPES.ADD_TRAINING,
        payload: payload
    };
};

export const getAllTrainingAction = () => {
    return {
        type: TYPES.GET_ALL_TRAINING,
    };
};

export const getAllTrainingSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_TRAINING_SUCCESS,
        payload: payload
    };
};

export const deleteTrainingAction = (payload) => {
    return {
        type: TYPES.DELETE_TRAINING,
        payload: payload
    };
};

export const editTrainingAction = (payload) => {
    return {
        type: TYPES.EDIT_TRAINING,
        payload: payload
    };
};

export const updateTrainingStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_TRAINING_STATUS,
        payload: payload
    };
};

export const deleteTrainingPDFAction = (payload) => {
    return {
        type: TYPES.DELETE_TRAINING_PDF,
        payload: payload
    };
};
